export default "__VITE_ASSET__80d37ab4__"